const attachRouters = [
  {
    path: 'attach',
    name: 'attach',
    redirect: '/manage/attach/list',
    component: () => import(/* webpackChunkName: "attach" */ '@/views/content'),
    meta: {
      sidebar: false,
      // 可查看用户列表的权限
      authKey: ['auth_attach', 'auth_attach_tree'],
      title: 'attach_menu',
      disabled: false,
      icon: 'menu_log2',
    },
    children: [
      // 列表
      {
        path: 'list',
        name: 'AttachList',
        component: () => import(/* webpackChunkName: "AttachList" */ '@/views/attach'),
        meta: {
          sidebar: false,
          authKey: ['auth_attach', 'auth_attach_tree'],
          breadcrumb: false,
          title: 'attach_menu',
          disabled: false,
          icon: 'menu_log2',
        },
      },
    ],
  },
];

export default attachRouters;
